import {
  RemoteStablishmentTables,
} from '../../../data/usecases/stablishment-tables/remote-stablishment-tables'
import { ChargeType } from '../../../presentation/enums/stablishment-tables'
import { formatCurrency } from '../../../presentation/helpers/helper-price'
import { currencyFormatWithDisplay } from '../../configs/currency'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const apiToForm = (response: any) => {
  const responseFormatted = Object.keys(response).map((key) => response[key])

  const initialData = responseFormatted.map((data: any) => {
    const item = {
      name: data.name,
      isActive: data.isActive,
      hasServiceCharge: String(data.hasServiceCharge),
      serviceType: String(data.serviceType),
      chargeType: String(data.chargeType),
      qrcodeUrl: data.qrcodeUrl,
      id: data.id,
    }

    if (data.chargeType === ChargeType.PERCENTAGE) {
      Object.assign(item, { chargeAmountPercentage: data.chargeAmount || 0 })
    } else {
      Object.assign(item, {
        chargeAmountFixed: formatCurrency(data.chargeAmount, currencyFormatWithDisplay, 'pt-BR') || 0,
      })
    }

    return item
  })

  return { tables: initialData }
}

export const makeStablishmentTables = (stablismentId: number) => (
  new RemoteStablishmentTables(
    `/stablishments/${stablismentId}/stablishment-tables`,
    makeAxiosHttpClient(),
  )
)

export const makeStablishmentTablesQRCode = (stablismentId: number, tableId: number) => (
  new RemoteStablishmentTables(
    `/stablishments/${stablismentId}/stablishment-tables/${tableId}/qrcode`,
    makeAxiosHttpClient(),
  )
)
